export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '内保单流水号',
            fixed: 'left',
            minWidth: 150
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'orgName',
            label: '机构名称',   
            minWidth: 100
        },
        {
            prop: 'saleName',
            label: '业务员名称',   
            minWidth: 100
        },
        {
            prop: 'beginTime',
            label: '内保起期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '内保止期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'return_date',
            label: '退统日期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'cusFee',
            label: '应交内保费（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'netFee',
            label: '净费（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'cusRebate',
            label: '折扣',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'cashRebate',
            label: '现金折扣比例',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'returnContractFee',
            label: '应退标准内保费',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'returnCusFee',
            label: '应退应交内保费',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'returnNetFee',
            label: '应退净费',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'days',
            label: '退统天数（天）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'cost',
            label: '退统费用',
            sortable: true,
            minWidth: 100
        },
        {
            prop: 'actual_cost',
            label: '实际退统费用',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'create_time',
            label: '退统创建时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'finance_time',
            label: '财务审核时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'apply_remark',
            label: '备注',
            minWidth: 200
        }
    ]
}

export default {}